export { default as ListadoArticulosInventario } from "./Listado";
